const templateUrl = require('./select-payment.html');

module.exports = function($stateProvider) {
  $stateProvider.state('billing.select', {
    resolve: {
      payments: ['paymentService', paymentService => paymentService.getPayments({ live: true })]
    },
    views: {
      'billing@': {
        templateUrl: templateUrl,
        controller: require('./select-payment.controller'),
        controllerAs: '$ctrl'
      }
    }
  });
};

module.exports.$inject = ['$stateProvider'];
